import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {getCsrfToken} from '../../../commons/authenticityToken';
import LoadingOverlay from 'react-loading-overlay';

const PurchaseComplete = (props) => {
  axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();

  // 合計金額
  const [ totallFee, setTotallFee ] = useState(0);
  // 企業ID
  const [ companyId, setCompanyId ] = useState(0);
  // エラーメッセージ
  const [errorMessage, setErrorMessage] = useState("");
  // ロード
  const [isLoading, setIsLoading]  = useState<Boolean>(true);

  // 初回ロード
  useEffect(() =>{
    let navigation: any = performance.getEntriesByType("navigation")[0];
    let coordinates = navigation.type;
    if( coordinates  != 'reload' ){
      axios.post(
        '/api/internal/tickets/data/purchase_complete', {
          company_id: props.company_id, m_ticket: props.tickets, total_fee: props.total_fee
          })
        .then(function (response) {
          setTotallFee(response.data.total_fee);
          setCompanyId(response.data.m_company_id);
          setIsLoading(false)
        })
        .catch(error => {
          setErrorMessage(error.response.data.message)
          setIsLoading(false)
        });
    }else{
      setTotallFee(props.total_fee);
      setCompanyId(props.company_id);
      setErrorMessage("不正なページ遷移です");
      setIsLoading(false);
    }

  },[])


  return(

    <LoadingOverlay active={isLoading} spinner text='Loading...'>
      { errorMessage && 
        <div className="alert alert-danger alert-dismissible" role="alert">
          <button 
          type="button"
          className="close"
          data-dismiss="alert"
          aria-label="閉じる">
              <span aria-hidden="true">×</span>
        </button>
          { errorMessage }
        </div>
      }
      <div className="mx-auto checkout-complete">
        { errorMessage ? (
          <>
            <span id="ticket-purchase-error">チケットを購入に失敗しました。</span>
            <br/>
          </>
        ):(
          <>        
            <span id="ticket-purchase-message">チケットを購入しました。</span>
            <br/>
            <span id="total-fee-message">{Number(totallFee).toLocaleString()}円</span>
            <br/>
          </>
        )
      }
        <a className="btn btn-primary ml5 form-btn"
              href={`/tickets/data/purchase${'?company_id=' + companyId}`}>チケット購入画面に戻る</a>
      </div>
    </LoadingOverlay>
  )
}

export default PurchaseComplete
